import PropTypes from "prop-types";
import axios from "axios";

import { CourseContentContext } from "./courseContentContext";
import { useState, useEffect } from "react";

export const CourseContentContextProvider = ({ children }) => {

  const apiUrl = import.meta.env.VITE_APP_API;
  const [questions, setQuestions] = useState([]);
  const [questionId, setQuestionId] = useState();
  const [url, setUrl] = useState(
    `${apiUrl}/api/exam/admin/organization_private_link/`
  );
  const [next, setNext] = useState(null);
  const [prev, setPrev] = useState(null);
  const [questionCount, setQuestionCount] = useState(null);

  const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))
    .token.access;

  useEffect(() => {
    async function getQuestions() {
      try {
        const result = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        });
        setQuestionCount(result.data.count);
        setPrev(result.data.previous);
        setNext(result.data.next);
        setQuestions(result.data.results);
      } catch (error) {
        console.error(error);
      }
    }
    getQuestions();
  }, [access_token, url]);

  return (
    <CourseContentContext.Provider
      value={{
        questions,
        setQuestions,
        questionId,
        setQuestionId,
        url,
        setUrl,
        next,
        prev,
        questionCount,
      }}
    >
      {children}
    </CourseContentContext.Provider>
  );
};

CourseContentContextProvider.propTypes = {
  children: PropTypes.any,
};
